import { render, staticRenderFns } from "./ClinicB.vue?vue&type=template&id=03a8f83e&scoped=true"
import script from "./ClinicB.vue?vue&type=script&lang=js"
export * from "./ClinicB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a8f83e",
  null
  
)

export default component.exports